// extracted by mini-css-extract-plugin
export default {"img":"animatedIng_img__j8AXy","inView":"animatedIng_inView__uF13G"};